<div class="modal-header">
  <h5 class="modal-title">{{ qrCode.id ? 'Chỉnh Sửa' : 'Thêm' }} Mã QR</h5>
  <button type="button" class="close" aria-label="Đóng" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form #qrCodeForm="ngForm" (ngSubmit)="onSaveClick()">
    <div class="form-group">
      <label for="isbn">
        ISBN
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô Tả:</b> Nhập số ISBN cho mã QR.<br><b>Ví Dụ:</b> 978-3-16-148410-0"></i>
      </label>
      <input type="text" class="form-control" id="isbn" [(ngModel)]="qrCode.isbn" name="isbn" placeholder="ví dụ: 978-3-16-148410-0" required>
      <div *ngIf="qrCodeForm.submitted && !qrCode.isbn" class="text-danger">ISBN là bắt buộc.</div>
    </div>
    <div class="form-group">
      <label for="width">
        Chiều Rộng
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô Tả:</b> Nhập chiều rộng của mã QR tính bằng pixel.<br><b>Ví Dụ:</b> 200"></i>
      </label>
      <input type="number" class="form-control" id="width" [(ngModel)]="qrCode.width" name="width" placeholder="ví dụ: 200" required>
      <div *ngIf="qrCodeForm.submitted && !qrCode.width" class="text-danger">Chiều rộng là bắt buộc.</div>
    </div>
    <div class="form-group">
      <label for="height">
        Chiều Cao
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô Tả:</b> Nhập chiều cao của mã QR tính bằng pixel.<br><b>Ví Dụ:</b> 200"></i>
      </label>
      <input type="number" class="form-control" id="height" [(ngModel)]="qrCode.height" name="height" placeholder="ví dụ: 200" required>
      <div *ngIf="qrCodeForm.submitted && !qrCode.height" class="text-danger">Chiều cao là bắt buộc.</div>
    </div>
    <div class="form-group">
      <label for="margin">
        Lề
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô Tả:</b> Nhập lề xung quanh mã QR tính bằng pixel.<br><b>Ví Dụ:</b> 10"></i>
      </label>
      <input type="number" class="form-control" id="margin" [(ngModel)]="qrCode.margin" name="margin" placeholder="ví dụ: 10" required>
      <div *ngIf="qrCodeForm.submitted && !qrCode.margin" class="text-danger">Lề là bắt buộc.</div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onCancelClick()">Hủy</button>
      <button type="submit" class="btn btn-primary" [disabled]="qrCodeForm.invalid">Lưu</button>
    </div>
  </form>
</div>
